import {createAction} from '@reduxjs/toolkit'
import {LoginFormData} from 'interfaces'
export const login = createAction<
  LoginFormData & {
    redirectTo: string
  }
>('Login')
export const loginSuccess = createAction('LoginSuccess')
export const loginFailure = createAction('LoginFailure')
